import React, { useEffect, useState } from 'react';
import { Paper, Table, Checkbox, Flex, Text, Button } from '@mantine/core';
import { TbArrowLeft } from 'react-icons/tb';

interface Fund {
  id: number;
  name: string;
}

interface SelectedJurisdiction {
  reportingMemberState: string;
  funds: number[];
}

interface FundsProps {
  funds?: Fund[];
  reportingMemberState: string;
  selectedJurisdictions: SelectedJurisdiction[];
  onSaveFunds: (selectedFundIds: number[], reportingMemberState: string) => void;
}

export const Funds = ({
  funds = [],
  reportingMemberState,
  selectedJurisdictions,
  onSaveFunds
}: FundsProps) => {
  const [selectedFundIds, setSelectedFundIds] = useState<number[]>([]);

  const selectedJurisdiction = selectedJurisdictions.find(
    item => item.reportingMemberState === reportingMemberState
  );

  useEffect(() => {
    setSelectedFundIds(selectedJurisdiction?.funds || []);
  }, [selectedJurisdiction]);

  const onSelectFund = (id: number): void => {
    if (selectedFundIds.includes(id)) {
      setSelectedFundIds(prev => prev.filter(value => value !== id));
    } else {
      setSelectedFundIds(prev => [...prev, id]);
    }
  };

  const onSelectAllFunds = (): void => {
    if (selectedFundIds.length === funds.length) {
      setSelectedFundIds([]);
    } else {
      setSelectedFundIds(funds.map(item => item.id));
    }
  };

  const rows = funds.map((element: Fund) => {
    return (
      <Table.Tr key={element.id}>
        <Table.Td fz="14px" fw={600} lh="20px" c="#25262B" p="20px 12px">
          <Flex align="center" gap="8px">
            <Checkbox
              onChange={() => onSelectFund(element.id)}
              checked={selectedFundIds.includes(element.id)}
              size="xs"
            />
            {element.name}
          </Flex>
        </Table.Td>
      </Table.Tr>
    );
  });

  return (
    <>
      {/* @ts-ignore */}
      <Paper
        id="export-drawer-funds-paper"
        withBorder
        radius="sm"
        p="0"
        sx={{ overflow: 'hidden' }}
      >
        <Table id="export-drawer-funds-table" withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th id="export-drawer-funds-header-cell" p="10px 8px" c="#868E96" bg="#F8F9FA">
                <Flex id="export-drawer-funds-header-row" justify="space-between" align="center">
                  <Flex id="export-drawer-funds-select-all-row" align="center" gap="8px">
                    <Checkbox
                      id="export-drawer-funds-select-all-checkbox"
                      checked={selectedFundIds.length === funds.length}
                      size="xs"
                      onChange={() => onSelectAllFunds()}
                    />
                    All AIFs
                  </Flex>
                  <Text
                    id="export-drawer-funds-selected-count"
                    c="#868E96"
                    fz="14px"
                    fw={600}
                    lh="20px"
                  >
                    {selectedFundIds.length} AIFs
                  </Text>
                </Flex>
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </Paper>

      <Flex id="export-drawer-funds-actions" justify="flex-end" mt="32px">
        <Button
          id="export-drawer-funds-save-button"
          onClick={() => onSaveFunds(selectedFundIds, reportingMemberState)}
          size="xs"
          leftSection={<TbArrowLeft size={16} />}
        >
          Save
        </Button>
      </Flex>
    </>
  );
};
